<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form" v-loading="loading">
        <!--        货主支付-->
        <template v-if="form.stepType === 5">
          <div class="custom-form-content">
            <div>
              <span class="label">支付时间：</span>
              <span class="value">{{ detail.paymentTime || "-" }}</span>
            </div>
            <div>
              <span class="label">支付金额：</span>
              <span class="value">{{ detail.paymentAmount || "-" }}元</span>
            </div>
            <div>
              <span class="label">支付方式：</span>
              <span class="value" v-if="detail.paymentMethod === 10">微信支付</span>
              <span class="value" v-if="detail.paymentMethod === 20">钱包支付</span>
            </div>
            <div>
              <span class="label">支付来源：</span>
              <span class="value" v-if="detail.payFrom === 1">货主支付</span>
              <span class="value" v-if="detail.payFrom === 2">司机代付</span>
            </div>
            <div>
              <span class="label">支付订单号：</span>
              <span class="value">{{ detail.paymentNo || "-" }}</span>
            </div>
          </div>
        </template>
        <!--        订单取消-->
        <template v-if="form.stepType === 31">
          <div class="custom-form-content">
            <div>
              <span class="label">取消时间：</span>
              <span class="value">{{ detail.cancelTime || "-" }}</span>
            </div>
            <div>
              <span class="label">申请人类型：</span>
              <span class="value" v-if="detail.cancelType === 1">超时取消</span>
              <span class="value" v-if="detail.cancelType === 2">司机取消</span>
              <span class="value" v-if="detail.cancelType === 3">货主取消</span>
              <span class="value" v-if="detail.cancelType === 4">客服取消</span>
            </div>
            <div v-if="detail.cancelType === 4">
              <span class="label">操作人姓名：</span>
              <span class="value">{{ detail.cancelUserName || "-" }}</span>
            </div>
<!--            <div>-->
<!--              <span class="label">取消原因：</span>-->
<!--              <span class="value">{{ detail.cancelMsg || "-" }}</span>-->
<!--            </div>-->
          </div>
        </template>
        <!--        派单详情-->
        <template v-if="form.stepType === 10">
          <div class="custom-form-content">
            <div>
              <span class="label">派单时间：</span>
              <span class="value">{{ detail.dispatchTime || "-" }}</span>
            </div>
            <div>
              <span class="label">派单调度：</span>
              <span class="value">{{ detail.dispatcherName || "-" }}</span>
            </div>
            <div>
              <span class="label">指派车牌：</span>
              <span class="value">{{ detail.carNumber || "-" }}</span>
            </div>
          </div>
        </template>
        <!--        改派详情-->
        <template v-if="form.stepType === 11">
          <div class="custom-form-content">
            <div>
              <span class="label">改派时间：</span>
              <span class="value">{{ detail.dispatchTime || "-" }}</span>
            </div>
            <div>
              <span class="label">申请调度：</span>
              <span class="value">{{ detail.dispatcherName || "-" }}</span>
            </div>
            <div>
              <span class="label">改派审批人：</span>
              <span class="value">{{ detail.auditUserName || "-" }}</span>
            </div>
            <div>
              <span class="label">原承运车辆车牌：</span>
              <span class="value">{{ detail.oldCarNumber || "-" }}</span>
            </div>
            <div>
              <span class="label">改派后车辆车牌：</span>
              <span class="value">{{ detail.newCarNumber || "-" }}</span>
            </div>
            <div>
              <span class="label">改派原因：</span>
              <span class="value">{{ detail.msg }}</span>
            </div>
          </div>
        </template>
        <!--        装卸货详情-->
        <template v-if="form.stepType === 21 || form.stepType === 22">
          <div class="custom-form-content">
            <div>
              <span class="label">完成时间：</span>
              <span class="value">{{ detail.completeTime }}</span>
            </div>
            <div>
              <span class="label">获取情况：</span>
              <span class="value colorFFD023" v-if="detail.completeStatus === 0">未完成</span>
              <span class="value color1269FF" v-if="detail.completeStatus === 1">货物正常</span>
              <span class="value colorf32009" v-if="detail.completeStatus === 2">货物异常</span>
            </div>
            <div>
              <span class="label">异常说明：</span>
              <span class="value">{{ detail.completeMsg || "-" }}</span>
            </div>
            <div>
              <span class="value">
                <div class="common-image-box">
                  <el-image
                    v-for="(item, index) in detail.pointPictures"
                    :key="index"
                    :src="getFileUrl(item)"
                    class="common-image"
                    :preview-src-list="[getFileUrl(item)]"></el-image>
                  <el-image
                    v-for="(item, index) in detail.receiptPictures"
                    :key="index"
                    :src="getFileUrl(item)"
                    class="common-image"
                    :preview-src-list="[getFileUrl(item)]"></el-image>
                </div>

              </span>
            </div>
          </div>
        </template>
        <!--        退款详情-->
        <template v-if="form.stepType === 41">
          <div class="custom-form-content">
            <div>
              <span class="label">退款时间：</span>
              <span class="value">{{ detail.refundTime || "-" }}</span>
            </div>

            <div>
              <span class="label">退款金额：</span>
              <span class="value">{{detail.refundAmount}}元</span>
            </div>
            <div>
              <span class="label">退款状态：</span>
              <span class="value" v-if="detail.refundStatus === -1">
                <el-tag type="danger">退款失败</el-tag>
              </span>
              <span class="value" v-if="detail.refundStatus === 0">
               <el-tag type="success">退款中</el-tag>
              </span>
              <span class="value" v-if="detail.refundStatus === 1">
               <el-tag>退款成功</el-tag></span>
            </div>
            <div>
              <span class="label">退款方式：</span>
              <span class="value" v-if="detail.paymentMethod === 10">微信</span>
              <span class="value" v-if="detail.paymentMethod === 20">钱包</span>
            </div>
            <div>
              <span class="label">支付订单号：</span>
              <span class="value">{{ detail.sourcePaymentNo || "-" }}</span>
            </div>
          </div>
        </template>
        <!--        回单详情-->
        <template v-if="form.stepType === 25">
          <div class="custom-form-content">
            <div>
              <span class="label">回单人姓名：</span>
              <span class="value">{{ detail.handleUsername || "-" }}</span>
            </div>
            <div>
              <span class="label">回单时间：</span>
              <span class="value">{{ detail.handleTime || "-" }}</span>
            </div>

            <div>
              <span class="label">回单方式：</span>
              <span class="value" v-if="detail.receiptWay === 1">线下带回</span>
              <span class="value" v-if="detail.receiptWay === 2">快递</span>
            </div>
            <div v-if="detail.receiptWay === 2">
              <span class="label">快递信息：</span>
              <span class="value" >{{detail.handleMsg}}</span>
            </div>

          </div>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {
  getCancelDetail,
  getDispatchDetail,
  getPage,
  getPayDetail,
  getPointDetail,
  getReassignDetail, getReceiveDetail,
  getTuiDetail,
  setReal
} from "./api";
import UploadFiles2 from "@/components/UploadFiles4.vue";
// import CustomTable from "@/components/CustomTable.vue";
// import tableMixin from "@/mixin/tableMixin";
import CustomCopy from "@/components/CustomCopy.vue";
import { getFileUrl } from "@/utils/tool";

export default {
  name: "StepDetail",
  // mixins: [tableMixin],
  components: {
    CustomCopy,
    // CustomTable,
    UploadFiles2,
    DialogContainer,
  },
  data() {
    return {
      getFileUrl,
      getTableMethod: getPage,
      cheImage: require("@/assets/imgs/title.png"),
      imageUrl: require("@/assets/imgs/bg.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "详情",
        closeOnClickModal: false,
        appendToBody: true,
        confirmFn: null,
        beforeClose: (v) => {
          this.detail = {};
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {},
      detail: {},
      loading: false,
    };
  },
  mounted() {},
  methods: {
    init(item) {
      this.dialogObj.title = item.content;
      this.form = Object.assign({}, item);
      this.dialogObj.show = true;
      this.getDetail(this.form.stepType, this.form.stepId);
    },
    getDetail(stepType, stepId) {
      this.loading = true;
      // 1货主下单，2客服代下单，5货主支付，10调度派单，11订单改派，21装货点装货，22卸货点卸货，31订单取消，41订单退款
      let methodApi = "";
      switch (stepType) {
        case 5:
          methodApi = getPayDetail;
          break;
        case 10:
          methodApi = getDispatchDetail;
          break;
        case 11:
          methodApi = getReassignDetail;
          break;
        case 21:
          methodApi = getPointDetail;
          break;
        case 22:
          methodApi = getPointDetail;
          break;
        case 25:
          methodApi = getReceiveDetail;
          break;
        case 31:
          methodApi = getCancelDetail;
          break;
        case 41:
          methodApi = getTuiDetail;
          break;
      }
      methodApi(stepId)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.detail = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .custom-form-content {
    line-height: 0.3rem;
  }
}
</style>
